import { AfterViewInit, ChangeDetectorRef, Component, computed, ElementRef, input, OnDestroy, ViewChild, inject, output } from '@angular/core';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { EmptyValuePipe, TruncatePipe } from '@htx/core';
import { MatIcon } from '@angular/material/icon';
import { MatChip, MatChipListbox } from '@angular/material/chips';

import { MatMenu, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-service-offer-entity-card',
  imports: [
    MatCard,
    EmptyValuePipe,
    TruncatePipe,
    MatCardContent,
    MatIcon,
    MatChipListbox,
    MatChip,
    MatCardTitle,
    MatMenuTrigger,
    MatMenu,
    TranslocoPipe
  ],
  templateUrl: './service-offer-entity-card.component.html',
  styleUrl: './service-offer-entity-card.component.scss'
})
export class ServiceOfferEntityCardComponent implements AfterViewInit, OnDestroy {
  translocoService = inject(TranslocoService);
  cdr = inject(ChangeDetectorRef);

  title = input<string>();
  serviceType = input<string>();
  serviceID = input<string>();
  description = input<string>();
  language = input<string>();
  publisher = input<string>();
  sovereign = input<string>();
  dataOfferSource = input<string>();
  datasource = input<string>();
  method = input<string>();
  baseUrl = input<string>();
  keywords = input<string[]>();
  subCategory = input<string>();
  showEditDeleteButtons = input<boolean>();
  titleClick = output<void>();

  tagList = computed(() => {
    const kw = this.keywords();
    if (!kw) return [];
    if (Array.isArray(kw)) {
      return kw.map((tag: string) => tag.trim()).filter((tag: string) => tag.length > 0);
    }
    // JSON-LD may return a single string instead of an array
    if (typeof kw === 'string' && (kw as string).trim()) {
      return (kw as string).split(',').map(s => s.trim()).filter(Boolean);
    }
    return [];
  });

  @ViewChild('chipRow', { read: ElementRef }) chipRow!: ElementRef<HTMLElement>;

  totalTags = 0;
  visibleTags: string[] = [];
  hiddenTagCount = 0;

  resizeObserver!: ResizeObserver;

  ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(() => this.recalculateVisible());
    this.resizeObserver.observe(this.chipRow.nativeElement);
  }

  ngOnDestroy() {
    this.resizeObserver.disconnect();
  }

  recalculateVisible() {
    const tags = this.tagList();
    this.totalTags = tags.length;
    if (!this.chipRow || tags.length === 0) {
      this.visibleTags = [];
      this.hiddenTagCount = 0;
      return;
    }

    const containerWidth = this.chipRow.nativeElement.clientWidth;
    let used = 0;
    const fits: string[] = [];

    const measureEl = document.createElement('mat-chip');
    measureEl.style.position = 'absolute';
    measureEl.style.visibility = 'hidden';
    measureEl.classList.add('tag-chip');
    document.body.appendChild(measureEl);

    for (const tag of tags) {
      measureEl.textContent = tag;
      const w = measureEl.offsetWidth + 40;
      if (used + w <= containerWidth) {
        used += w;
        fits.push(tag);
      } else {
        break;
      }
    }

    document.body.removeChild(measureEl);

    this.visibleTags = fits;
    this.hiddenTagCount = tags.length - fits.length;
    this.cdr.detectChanges();
  }

  translateEnum(enumValue: string, enumType: string): string {
    return this.translocoService.translate(`${enumType}.${enumValue}`);
  }

  isTruncated(description: string | undefined): boolean {
    return !!description && description.length > 120;
  }
}
